export const stripAnalystHtml = (value) =>
  (value || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();

export const truncateAlertPreview = (html, max = 120) => {
  const text = stripAnalystHtml(html);
  if (!text || text.length <= max) return text || "Alert";
  return `${text.slice(0, max).trim()}…`;
};
